// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { PayOrderCustomerActionResponseDTO } from '../models';
import { ReferenceDTO } from '../models';
import { SignOrderCustomerActionResponseDTO } from '../models';
import { UpdateAboutYouAttributesDTO } from '../models';
import { UpdateAddressHistoryAttributesDTO } from '../models';
/**
 * OrderCustomerActionsApi - axios parameter creator
 * @export
 */
export const OrderCustomerActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update user attributes for a product
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {UpdateAboutYouAttributesDTO} updateAboutYouAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aboutYou(orderId: string, customerId: string, updateAboutYouAttributesDTO: UpdateAboutYouAttributesDTO, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling aboutYou.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling aboutYou.');
            }
            // verify required parameter 'updateAboutYouAttributesDTO' is not null or undefined
            if (updateAboutYouAttributesDTO === null || updateAboutYouAttributesDTO === undefined) {
                throw new RequiredError('updateAboutYouAttributesDTO','Required parameter updateAboutYouAttributesDTO was null or undefined when calling aboutYou.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/about-you`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateAboutYouAttributesDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAboutYouAttributesDTO !== undefined ? updateAboutYouAttributesDTO : {}) : (updateAboutYouAttributesDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user address history for a product
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressHistory(orderId: string, customerId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling addressHistory.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addressHistory.');
            }
            // verify required parameter 'updateAddressHistoryAttributesDTO' is not null or undefined
            if (updateAddressHistoryAttributesDTO === null || updateAddressHistoryAttributesDTO === undefined) {
                throw new RequiredError('updateAddressHistoryAttributesDTO','Required parameter updateAddressHistoryAttributesDTO was null or undefined when calling addressHistory.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/address-history`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateAddressHistoryAttributesDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAddressHistoryAttributesDTO !== undefined ? updateAddressHistoryAttributesDTO : {}) : (updateAddressHistoryAttributesDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete a confirm customer action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm(orderId: string, customerId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling confirm.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling confirm.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/confirm`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a payment intent secret to pay for an order
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {string} [customerActionType] CustomerActionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pay(orderId: string, customerId: string, customerActionType?: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling pay.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling pay.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/pay`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerActionType !== undefined) {
                localVarQueryParameter['customerActionType'] = customerActionType;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create and run a reference check immediately for a user
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reference(orderId: string, customerId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling reference.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling reference.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/reference`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete a sign customer action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sign(orderId: string, customerId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling sign.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling sign.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/sign`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete a sign tenancy addendum action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendumForTenant(orderId: string, customerId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling signAddendumForTenant.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling signAddendumForTenant.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/actions/sign-addendum`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderCustomerActionsApi - functional programming interface
 * @export
 */
export const OrderCustomerActionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Update user attributes for a product
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {UpdateAboutYouAttributesDTO} updateAboutYouAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aboutYou(orderId: string, customerId: string, updateAboutYouAttributesDTO: UpdateAboutYouAttributesDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).aboutYou(orderId, customerId, updateAboutYouAttributesDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update user address history for a product
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressHistory(orderId: string, customerId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).addressHistory(orderId, customerId, updateAddressHistoryAttributesDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Complete a confirm customer action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm(orderId: string, customerId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).confirm(orderId, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve a payment intent secret to pay for an order
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {string} [customerActionType] CustomerActionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pay(orderId: string, customerId: string, customerActionType?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayOrderCustomerActionResponseDTO> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).pay(orderId, customerId, customerActionType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create and run a reference check immediately for a user
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reference(orderId: string, customerId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDTO> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).reference(orderId, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Complete a sign customer action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sign(orderId: string, customerId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignOrderCustomerActionResponseDTO> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).sign(orderId, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Complete a sign tenancy addendum action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendumForTenant(orderId: string, customerId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignOrderCustomerActionResponseDTO> {
            const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).signAddendumForTenant(orderId, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrderCustomerActionsApi - factory interface
 * @export
 */
export const OrderCustomerActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Update user attributes for a product
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {UpdateAboutYouAttributesDTO} updateAboutYouAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aboutYou(orderId: string, customerId: string, updateAboutYouAttributesDTO: UpdateAboutYouAttributesDTO, options?: any) {
            return OrderCustomerActionsApiFp(configuration).aboutYou(orderId, customerId, updateAboutYouAttributesDTO, options)(axios, basePath);
        },
        /**
         * Update user address history for a product
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressHistory(orderId: string, customerId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any) {
            return OrderCustomerActionsApiFp(configuration).addressHistory(orderId, customerId, updateAddressHistoryAttributesDTO, options)(axios, basePath);
        },
        /**
         * Complete a confirm customer action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm(orderId: string, customerId: string, options?: any) {
            return OrderCustomerActionsApiFp(configuration).confirm(orderId, customerId, options)(axios, basePath);
        },
        /**
         * Retrieve a payment intent secret to pay for an order
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {string} [customerActionType] CustomerActionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pay(orderId: string, customerId: string, customerActionType?: string, options?: any) {
            return OrderCustomerActionsApiFp(configuration).pay(orderId, customerId, customerActionType, options)(axios, basePath);
        },
        /**
         * Create and run a reference check immediately for a user
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reference(orderId: string, customerId: string, options?: any) {
            return OrderCustomerActionsApiFp(configuration).reference(orderId, customerId, options)(axios, basePath);
        },
        /**
         * Complete a sign customer action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sign(orderId: string, customerId: string, options?: any) {
            return OrderCustomerActionsApiFp(configuration).sign(orderId, customerId, options)(axios, basePath);
        },
        /**
         * Complete a sign tenancy addendum action
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendumForTenant(orderId: string, customerId: string, options?: any) {
            return OrderCustomerActionsApiFp(configuration).signAddendumForTenant(orderId, customerId, options)(axios, basePath);
        },
    };
};

/**
 * OrderCustomerActionsApi - interface
 * @export
 * @interface OrderCustomerActionsApi
 */
export interface OrderCustomerActionsApiInterface {
    /**
     * Update user attributes for a product
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {UpdateAboutYouAttributesDTO} updateAboutYouAttributesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    aboutYou(orderId: string, customerId: string, updateAboutYouAttributesDTO: UpdateAboutYouAttributesDTO, options?: any): AxiosPromise<{}>;

    /**
     * Update user address history for a product
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    addressHistory(orderId: string, customerId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any): AxiosPromise<{}>;

    /**
     * Complete a confirm customer action
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    confirm(orderId: string, customerId: string, options?: any): AxiosPromise<{}>;

    /**
     * Retrieve a payment intent secret to pay for an order
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {string} [customerActionType] CustomerActionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    pay(orderId: string, customerId: string, customerActionType?: string, options?: any): AxiosPromise<PayOrderCustomerActionResponseDTO>;

    /**
     * Create and run a reference check immediately for a user
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    reference(orderId: string, customerId: string, options?: any): AxiosPromise<ReferenceDTO>;

    /**
     * Complete a sign customer action
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    sign(orderId: string, customerId: string, options?: any): AxiosPromise<SignOrderCustomerActionResponseDTO>;

    /**
     * Complete a sign tenancy addendum action
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApiInterface
     */
    signAddendumForTenant(orderId: string, customerId: string, options?: any): AxiosPromise<SignOrderCustomerActionResponseDTO>;

}

/**
 * OrderCustomerActionsApi - object-oriented interface
 * @export
 * @class OrderCustomerActionsApi
 * @extends {BaseAPI}
 */
export class OrderCustomerActionsApi extends BaseAPI implements OrderCustomerActionsApiInterface {
    /**
     * Update user attributes for a product
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {UpdateAboutYouAttributesDTO} updateAboutYouAttributesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public aboutYou(orderId: string, customerId: string, updateAboutYouAttributesDTO: UpdateAboutYouAttributesDTO, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).aboutYou(orderId, customerId, updateAboutYouAttributesDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update user address history for a product
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public addressHistory(orderId: string, customerId: string, updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).addressHistory(orderId, customerId, updateAddressHistoryAttributesDTO, options)(this.axios, this.basePath);
    }

    /**
     * Complete a confirm customer action
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public confirm(orderId: string, customerId: string, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).confirm(orderId, customerId, options)(this.axios, this.basePath);
    }

    /**
     * Retrieve a payment intent secret to pay for an order
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {string} [customerActionType] CustomerActionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public pay(orderId: string, customerId: string, customerActionType?: string, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).pay(orderId, customerId, customerActionType, options)(this.axios, this.basePath);
    }

    /**
     * Create and run a reference check immediately for a user
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public reference(orderId: string, customerId: string, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).reference(orderId, customerId, options)(this.axios, this.basePath);
    }

    /**
     * Complete a sign customer action
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public sign(orderId: string, customerId: string, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).sign(orderId, customerId, options)(this.axios, this.basePath);
    }

    /**
     * Complete a sign tenancy addendum action
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomerActionsApi
     */
    public signAddendumForTenant(orderId: string, customerId: string, options?: any) {
        return OrderCustomerActionsApiFp(this.configuration).signAddendumForTenant(orderId, customerId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrderCustomerActionsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Update user attributes for a product
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {UpdateAboutYouAttributesDTO} updateAboutYouAttributesDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function aboutYou(
    orderId: string,
    customerId: string,
    updateAboutYouAttributesDTO: UpdateAboutYouAttributesDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).aboutYou(orderId, customerId, updateAboutYouAttributesDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update user address history for a product
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {UpdateAddressHistoryAttributesDTO} updateAddressHistoryAttributesDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addressHistory(
    orderId: string,
    customerId: string,
    updateAddressHistoryAttributesDTO: UpdateAddressHistoryAttributesDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).addressHistory(orderId, customerId, updateAddressHistoryAttributesDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Complete a confirm customer action
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function confirm(
    orderId: string,
    customerId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).confirm(orderId, customerId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Retrieve a payment intent secret to pay for an order
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {string} [customerActionType] CustomerActionType
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function pay(
    orderId: string,
    customerId: string,
    customerActionType?: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PayOrderCustomerActionResponseDTO> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).pay(orderId, customerId, customerActionType, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create and run a reference check immediately for a user
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function reference(
    orderId: string,
    customerId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ReferenceDTO> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).reference(orderId, customerId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Complete a sign customer action
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function sign(
    orderId: string,
    customerId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SignOrderCustomerActionResponseDTO> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).sign(orderId, customerId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Complete a sign tenancy addendum action
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function signAddendumForTenant(
    orderId: string,
    customerId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SignOrderCustomerActionResponseDTO> {
    const localVarAxiosArgs = OrderCustomerActionsApiAxiosParamCreator(configuration).signAddendumForTenant(orderId, customerId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

